<template>
  <b-modal
    id="addCandTalentPoolmodal"
    no-close-on-backdrop
    size="lg"
    centered
    hide-header
    hide-footer
    :visible="showCandTPModal"
    @show="populateModalData"
    @hidden="clearaddtojddetails"
  >
    <b-overlay :show="showSpinner" rounded="sm">
      <div class="cs-modal-header">
        <div>Add Candidates to Job</div>
        <div @click="clearaddtojddetails">
          <img
            class="rotate-on-hover"
            src="../../assets/img/accessconnew/blueCross.svg"
            alt=""
          />
        </div>
      </div>

      <div class="tp-modal-overflow-2">
        <b-row>
          <b-col cols="6">
            <div class="tp-add-cand-left">
              <div class="d-flex align-items-center justify-content-between">
                <div class="ct-table-bold-txt-3">Job Details</div>
                <div class="ct-table-bold-txt-3">
                  Total Job(s):
                  <span>{{ displayCount(addjddata.length) }}</span>
                </div>
              </div>
              <div class="tp-modal-card-2">
                <!-- parent div -->
                <div
                  class="mt-3 pointer"
                  v-for="(data, index) in addjddata"
                  :key="index"
                  @click="addtojddetails(data)"
                  :class="
                    particularCandidateDetails == data
                      ? 'tp-sub-card-first-2'
                      : 'tp-sub-card-2'
                  "
                >
                  <!-- card design -->
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div
                      class="ct-table-bold-txt-4 text-truncate"
                      style="width: 50%"
                      v-b-popover.hover.bottom="data.jobName"
                    >
                      {{ data.jobName }}
                    </div>
                    <div class="ct-table-bold-txt-4">
                      Candidate(s):
                      {{ displayCount(data.successCount + data.failedCount) }}
                    </div>
                  </div>
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      mt-2
                      tp-text
                    "
                  >
                    <div class="tp-green-text-2">
                      Success:
                      <span>
                        {{ displayCount(data.successCount) }}
                      </span>
                    </div>
                    <div class="tp-red-text-2">
                      Failure:
                      <span>{{ displayCount(data.failedCount) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>

          <b-col cols="6">
            <div class="tp-second-right-overflow-2 tp-add-cand-left">
              <div class="d-flex align-items-center justify-content-between">
                <div class="ct-table-bold-txt-3">Candidates Details</div>
                <div class="ct-table-bold-txt-3">
                  Total Candidate(s):
                  <span>{{
                    selectedCandidate
                      ? displayCount(selectedCandidate)
                      : displayCount(
                          candidateSelectedToThirdParty.candidates.length
                        )
                  }}</span>
                </div>
              </div>
              <div v-if="particularCandidateDetails.failed.length > 0">
                <div class="tp-side-modal-card-red mt-3">
                  <div
                    class="ct-table-bold-txt-4 d-flex justify-content-between"
                  >
                    <div>Existing Candidates</div>
                    <div>
                      {{
                        displayCount(particularCandidateDetails.failed.length)
                      }}
                    </div>
                  </div>
                  <div class="tp-text-1">
                    These candidates have already been added to this job
                  </div>

                  <div class="tp-second-modal-white-box mt-2">
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between
                        p-2
                        tp-below-text
                        defaultCursor
                      "
                      v-for="(i, index) in particularCandidateDetails.failed"
                      :key="index"
                    >
                      <div class="text-truncate" style="width: 50%">
                        <div class="ellipsis tp-below-text">
                          <span v-b-tooltip.hover.right="i.name">
                            {{ i.name }}</span
                          >
                        </div>
                      </div>
                      <div class="text-truncate" style="width: 50%">
                        <div
                          class="ellipsis tp-text-1"
                          v-b-tooltip.hover.right="i.email"
                        >
                          {{ i.email }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="particularCandidateDetails.success.length > 0">
                <div class="tp-side-modal-card-green mt-3">
                  <div
                    class="ct-table-bold-txt-4 d-flex justify-content-between"
                  >
                    <div>Newly added Candidates</div>
                    <div>
                      {{
                        displayCount(particularCandidateDetails.success.length)
                      }}
                    </div>
                  </div>
                  <div class="tp-text-1">
                    These candidates are successfully added to the job
                  </div>
                  <div class="tp-second-modal-white-box mt-2">
                    <div
                      class="
                        d-flex
                        p-2
                        align-items-center
                        justify-content-between
                        tp-below-text
                        defaultCursor
                      "
                      v-for="(i, index) in particularCandidateDetails.success"
                      :key="index"
                    >
                      <div class="text-truncate" style="width: 50%">
                        <div class="ellipsis tp-below-text">
                          <span v-b-tooltip.hover.right="i.name">{{
                            i.name
                          }}</span>
                        </div>
                      </div>
                      <div class="text-truncate" style="width: 50%">
                        <div
                          class="ellipsis tp-text-1"
                          v-b-tooltip.hover.right="i.email"
                        >
                          {{ i.email }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div
        class="
          d-flex
          align-items-center
          justify-content-end
          border-top
          pt-2
          pb-3
          pr-4
          bluebtn
        "
      >
        <b-button
          @click="
            from === 'cvSearch' ? goToAddToTalentPool() : clearaddtojddetails()
          "
          class="acs-addBtn-modal mt-1"
          >Okay</b-button
        >
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>
import { mapGetters } from "vuex";
import {
  addtojd,
  addCacheCandidates,
  thirdPartyImportCheck,
  addCandidatestoDB,
} from "../../utils/apiFunctions";
import toast from "../../components/mixin/toast";
export default {
  name: "AddToJDSuceessMultiple",
  props: {
    from: String,
    selectedjd: Array,
    candidateSelected: Array,
    showCandTPModal: Boolean,
    posType: String,
    candPosData: Object,
    candidateSelectedToThirdParty: Object,
  },
  mixins: [toast],
  data() {
    return {
      addjddata: [],
      particularCandidateDetails: {
        failed: [],
        success: [],
      },
      showSpinner: false,
    };
  },
  computed: {
    ...mapGetters("cvSearchVUEX", {
      whereFrom: "whereFrom",
    }),
    selectedCandidate() {
      return this.candidateSelected?.length || 0;
    },
    candidateEmails() {
      if (Object.keys(this.candidateSelectedToThirdParty).length > 0) {
        return this.candidateSelectedToThirdParty.candidates.map(
          (candidate) => candidate.email
        );
      }
      return [];
    },
  },
  methods: {
    populateModalData() {
      switch (this.from) {
        case "cvSearch":
          this.setSendToThirdParty();
          break;
        case "talentpool":
          this.addCandidateToJD();
          break;
        case "addtotalentpool":
          this.addThirdPartyCandidates();
          break;
        default:
          break;
      }
    },
    displayCount(data) {
      if (data < 9) {
        return "0" + data;
      } else {
        return data;
      }
    },
    async addThirdPartyCandidates() {
      this.showSpinner = true;
      try {
        const payload = {
          emails: this.candidateSelectedToThirdParty.candidates,
          jobIDs: this.selectedjd,
        };
        if (this.posType && this.posType == "automatic")
          payload.automatic = true;
        else if (
          this.posType &&
          this.posType == "manual" &&
          Object.keys(this.candPosData).length != 0
        ) {
          payload.positions = this.candPosData;
        }
        const res = await addCandidatestoDB(payload);

        if (res.status === 200) {
          this.showLoader = false;
          this.addjddata = res.data.data.jds;
          this.particularCandidateDetails = this.addjddata[0];
          if (this.posType) this.$emit("close-modals");
        } else {
          if (this.posType) this.$emit("close-modals");
          this.errorModal(res.data.data.Details);
        }
        this.showSpinner = false;
      } catch (error) {
        this.showSpinner = false;
        if (this.posType) this.$emit("close-modals");
        console.error(error);
      }
    },
    async setSendToThirdParty() {
      try {
        this.$store.commit("cvSearchVUEX/setJobIDs", this.selectedjd);
        let payload = {
          emailIDs: this.candidateEmails,
          jobIDs: this.selectedjd,
        };
        const res = await thirdPartyImportCheck(payload);
        if (res.status == 200) {
          this.addjddata = res.data.data.jds;
          this.particularCandidateDetails = this.addjddata[0];
          this.showCandTPModal = true;
        }
      } catch (error) {
        console.error("err:", error);
      }
    },
    async goToAddToTalentPool() {
      try {
        const res = await addCacheCandidates(
          this.candidateSelectedToThirdParty
        );
        if (res.status == 200) {
          // Calculate the sum of successCount values
          const totalSuccessCount = this.addjddata.reduce(
            (total, item) => total + item.successCount,
            0
          );

          // Check if the total sum is zero
          if (totalSuccessCount === 0) {
            this.whereFrom === "kanban" ? this.$emit("candidates-failed") : "";
            this.clearaddtojddetails();
          } else {
            this.$router.push({
              name: "AddFromThirdParty",
              query: {
                fromPage: "addjobs",
              },
            });
          }
        }
      } catch (error) {
        console.error("err:", error);
      }
    },
    addtojddetails(data) {
      this.particularCandidateDetails = data;
    },
    clearaddtojddetails() {
      this.particularCandidateDetails = { failed: [], success: [] };
      this.addjddata = [];
      this.$emit("hide-cand-tp-modal");
    },
    async addCandidateToJD() {
      this.showSpinner = true;
      try {
        let data = null;
        data = {
          jobIDs: this.selectedjd,
          candidateIDs: this.candidateSelected,
        };
        if (this.posType && this.posType == "automatic") data.automatic = true;
        else if (
          this.posType &&
          this.posType == "manual" &&
          Object.keys(this.candPosData).length != 0
        ) {
          data.positions = this.candPosData;
        }
        const response = await addtojd(data);

        if (response.status === 200) {
          this.addjddata = response.data.data.jds;
          this.particularCandidateDetails = this.addjddata[0];
          this.successModal(response.data.data.Details);
        }
        if (this.posType) this.$emit("close-modals");
        this.showSpinner = false;
      } catch (error) {
        if (this.posType) this.$emit("close-modals");
        this.showSpinner = false;
        this.errorModal("Something went wrong!");
      }
    },
  },
};
</script>
